module.exports = __webpack_public_path__ + "img/ico_loading.4ae50a1e.png";